import { useEffect, useState } from 'react';

function useLocalStorage(key, initialValue) {
  const [error, setError] = useState(null);
  const [state, setState] = useState(() => {
    try {
      const storedValue = localStorage.getItem(key);
      return storedValue !== null ? JSON.parse(storedValue) : initialValue;
    } catch (err) {
      setError(err);
      return initialValue;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(key, JSON.stringify(state));
    } catch (err) {
      setError(err);
    }
  }, [key, state]);

  return [state, setState, error];
}

export default useLocalStorage;
